export default __webpack_public_path__ + "ultimate-champion-mobile-cn-ab843f7b007f5f8b6e88a94c1d2d7692.png";